import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui'
import Vue from 'vue'
import store from '@/store'
import router from '@/router'

Vue.component(Message.name, Message)

axios.interceptors.request.use(config => {
  // 发起请求
  if (store.state.base.token) {
    config.headers.Authorization = `Bearer ${store.state.base.token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401) {
    store.commit('removeToken')
    router.replace({
      path: '/login'
    })
  }
  return Promise.resolve(error.response)
})

function checkStatus (response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400 || response.status === 502)) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}

function checkCode (res) {
  let rd = res.data
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    Message.error(res.msg)
  }
  if (rd.code || rd.code === 0) {
    switch (rd.code) {
      case 2000:
      case 2001:
        store.commit('removeToken')
        Message.error('信息校验失败，请重新登录')
        router.replace({
          path: '/login'
        })
        break
      case 2002:
        store.commit('removeToken')
        Message.error('登录信息已过期，请重新登录')
        router.replace({
          path: '/login'
        })
        break
      case 2003:
      case 2004:
      case 2005:
        store.commit('removeToken')
        Message.error('您的账号已在其它设备登录，请重新登录')
        router.replace({
          path: '/login'
        })
        break
      case 200:
        break
      default:
        rd.msg && Message.error(rd.msg)
        break
    }
  }
  return res
}

export default {
  post (url, data, formData) {
    data = formData ? data : qs.stringify(data)
    return axios({
      method: 'post',
      url,
      data: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  get (url, params) {
    return axios({
      method: 'get',
      url,
      params,
      headers: {'X-Requested-With': 'XMLHttpRequest'}
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  downLoad (url, params) {
    return axios({
      method: 'get',
      url,
      params,
      responseType: 'blob',
      headers: {'X-Requested-With': 'XMLHttpRequest'}
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  put (url, params) {
    return axios({
      method: 'put',
      url,
      params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  del (url, params) {
    return axios({
      method: 'delete',
      url,
      params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/http/index.js